module.exports = __webpack_public_path__ + "img/metamask.a7f91db6.svg";